
import { Request } from "@cttq/cttq-request";

let serverInstance = new Request({
	baseURL: import.meta.env.VITE_CRM_URL,
});


export function getAreaList(){
	return serverInstance.get({
		url: `/crm/dataConfig/areaList`
	});
}


export function getClientInit(){
	return serverInstance.get({
		url: `/crm/init?dicType=0`
	});
}

export function crmInit(){
	return serverInstance.get({
		url: `/crm/init?dicType=0`,
	});
}


export function getProductList(data: any){
	return serverInstance.post({
		url: `/crm/product/getProductList2`,
		data
	});
}

export function queryPerSupplierList(data: any){
	return serverInstance.post({
		url: `/pc/supplier/queryPerSupplierList`,
		data
	});
}

export function getPersonageClient(data: any){
	return serverInstance.post({
		url: `/crm/personageClient/list`,
		data
	});
}

export function geOrganizationList(data: any){
	return serverInstance.post({
		url: `/pc/crm/organization/list`,
		data
	});
}


